import apiMonolito from './apiMonolito';

/**
 * PDF de estudios: el médico los sube a la historia clínica y el paciente
 * los descarga desde "Mis estudios".
 */

// ---- Paciente ----
export async function getMisEstudios() {
  const response = await apiMonolito.get('/mis-estudios');
  return response.data;
}

export function descargarMiEstudio(archivo) {
  return descargarBlob(`/mis-estudios/${archivo.id}/descargar`, archivo.nombre_archivo);
}

// ---- Médico ----
export async function getArchivosPaciente(pacienteId) {
  const response = await apiMonolito.get(`/historia-clinica/${pacienteId}/archivos`);
  return response.data;
}

export async function subirArchivoPaciente(pacienteId, { file, titulo, descripcion, fechaEstudio, consultaId }) {
  const form = new FormData();
  form.append('file', file);
  if (titulo) form.append('titulo', titulo);
  if (descripcion) form.append('descripcion', descripcion);
  if (fechaEstudio) form.append('fecha_estudio', fechaEstudio);
  if (consultaId) form.append('consulta_id', consultaId);
  const response = await apiMonolito.post(`/historia-clinica/${pacienteId}/archivos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

export function descargarArchivoPaciente(pacienteId, archivo) {
  return descargarBlob(`/historia-clinica/${pacienteId}/archivos/${archivo.id}`, archivo.nombre_archivo);
}

export async function eliminarArchivoPaciente(pacienteId, archivoId) {
  await apiMonolito.delete(`/historia-clinica/${pacienteId}/archivos/${archivoId}`);
}

// Se baja como blob (con el JWT del interceptor) y se dispara la descarga en el navegador
async function descargarBlob(url, nombre) {
  const response = await apiMonolito.get(url, { responseType: 'blob' });
  const objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = nombre || 'estudio.pdf';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(objectUrl);
}

export function formatearTamano(bytes) {
  if (!bytes) return '';
  return bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function mensajeError(error, porDefecto) {
  const respuesta = error && error.response;
  const mensaje = respuesta && respuesta.data && respuesta.data.error;
  if (mensaje) return mensaje;
  return respuesta && respuesta.status ? `${porDefecto} (código ${respuesta.status})` : porDefecto;
}
